@if (renderHeader) {
  <div
    class="mb-3"
    [class.header]="!customHeader"
    [class.sticky-header]="stickyHeader"
  >
    <ng-content select="[headerContent]"></ng-content>
  </div>
}

<div class="content" [class.fill-height]="fillHeight()">
  <ng-content select="[mainContent]"></ng-content>
</div>
